import { capitalize } from 'lodash-es';
import React from 'react';
import { Absolute, Box, Flex, Position } from '@marvelapp/ui';
import { SpecsPanelLabel, SpecsValue } from '@marvelapp/ui-internal';
import PanelSwatchLong from '../PanelSwatchLong';
export default function GradientFill(_a) {
    var gradientType = _a.gradientType, colors = _a.colors;
    return (React.createElement(Flex, { justifyContent: "space-between" },
        React.createElement(Box, null,
            React.createElement(SpecsPanelLabel, null, "Colour"),
            React.createElement(SpecsValue, { isDisabled: true }, "".concat(capitalize(gradientType), "\nGradient"))),
        React.createElement(Position, null,
            React.createElement(Absolute, { bg: "smokeDark", bottom: 10, left: "3px", top: 10, width: 2 }),
            colors.map(function (color, index) { return (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(Flex, { alignItems: "center", key: index, marginTop: index !== 0 ? 2 : 0 },
                React.createElement(Box, { bg: "white", border: "2px solid", borderColor: "smokeDark", borderRadius: "4px", height: "8px", marginRight: 2, position: "relative", width: "8px" }),
                React.createElement(PanelSwatchLong, { color: color }))); }))));
}
